export default __webpack_public_path__ + "video.86529b1b5104eeef222b7fee949256ce.svg";